import React from 'react';
import { ButtonDesktop } from '../../../../../../button/esm/desktop';

var styles = {"footer":"select__footer_1lca0"};
require('./index.css');

var Footer = function (_a) {
    var handleApply = _a.handleApply, handleClear = _a.handleClear, showClear = _a.showClear, _b = _a.selectedDraft, selectedDraft = _b === void 0 ? [] : _b;
    return (React.createElement("div", { 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0, className: styles.footer },
        React.createElement(ButtonDesktop, { size: 'xxs', view: 'primary', onClick: handleApply }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"),
        showClear && selectedDraft.length > 0 && (React.createElement(ButtonDesktop, { size: 'xxs', view: 'secondary', onClick: handleClear }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"))));
};

export { Footer };
